import React from 'react';
import { useTranslation } from 'react-i18next';

const BAND_COLOR = { good: 'text-green-600', fair: 'text-amber-600', poor: 'text-red-600', no_data: 'text-gray-400' };

function Chip({ label, v }) {
  return <span className="rounded-full bg-gray-100 px-3 py-1 text-xs text-gray-700">{label} −{v}</span>;
}

export default function DrivingScoreCard({ score }) {
  const { t } = useTranslation();
  if (!score) return null;
  const { score: value, band, penalties } = score;
  return (
    <div className="rounded-xl border bg-white p-4">
      <p className="text-xs uppercase tracking-wide text-gray-500">{t('ownerTelematics.score.title')}</p>
      {value === null ? (
        <p className="mt-1 text-gray-500">{t('ownerTelematics.score.noData')}</p>
      ) : (
        <>
          <p className="mt-1 text-3xl font-bold">
            <span className={BAND_COLOR[band]}>{value}</span>
            <span className="text-base font-normal text-gray-400"> / 100 · {t(`ownerTelematics.score.band.${band}`)}</span>
          </p>
          <div className="mt-2 flex flex-wrap gap-2">
            <Chip label={t('ownerTelematics.score.speeding')} v={penalties.speeding} />
            <Chip label={t('ownerTelematics.score.braking')} v={penalties.braking} />
            <Chip label={t('ownerTelematics.score.night')} v={penalties.night} />
          </div>
        </>
      )}
    </div>
  );
}
